const project = {
    normalText: "My",
    strongText: 'Project',
    content: [
        {
            "id": 0,
            "name": 'Telegram Bot Info Covid-19 Indonesia',
            "category": "python",
            "aboutProject": `In this project, I made a telegram bot that provide information about the development of Covid-19 in Indonesia, such as the number of positive patients, the number of recovered patients, the number of patients being treated and the number of patients who died.
        
            This project was made using the Python programming language in combination with the Telegram Bot API.`,
            "tags": ["Python", "Telegram Bot API"],
            "button": {
                "Demo": 'https://t.me/Covid_SembilanBelas_Info_Bot',
                "Github": 'https://github.com/tisoga/telegram_bot_covid_19',
                "Private": false,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": false,
            }
        },
        {
            "id": 1,
            "name": 'Web Scraping for Journal or Paper in Google Scholar',
            "category": "python",
            "aboutProject": `This project functions is to retrieve information about journals or papers from the author's profile on the Google Scholar-web, information such as: Journal title, Year of publication, Author journal and a link to the journal. The retrieved information is then stored in a .CSV file.
            This project was made using Python programming language together with one of the web scraping libraries, Beautifulsoup.`,
            "tags": ["Python", "Web Scraping", "Beautifulsoup"],
            "button": {
                "Demo": false,
                "Github": 'https://github.com/tisoga/get_data_journal_google_schoolar',
                "Private": false,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": false,
            }
        },
        {
            "id": 2,
            "name": 'Web Scraping for All Information and All Pokemon Images',
            "category": "python",
            "aboutProject": `This project functions to retrieve information and store Pokemon images from generation 1 to generation 8. The information used is the Pokemon name and type of Pokemon. The retrieved information is then stored in a .CSV file, as images are stored in the same folder as this file.
            This project was made using Python programming language together with one of the web scraping libraries, Beautifulsoup.`,
            "tags": ["Python", "Web Scraping", "Beautifulsoup"],
            "button": {
                "Demo": false,
                "Github": 'https://github.com/tisoga/get_pokemon_data',
                "Private": false,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": false,
            }
        },
        {
            "id": 3,
            "name": 'This Portfolio Website',
            "category": "web",
            "aboutProject": `The Purpose of this website is to show some project that I have been working on.
        
            This website was created with React.JS using the Tailwind CSS Framework.`,
            "tags": ["HTML + CSS", "ReactJS", "Tailwind"],
            "button": {
                "Demo": false,
                "Github": 'https://github.com/tisoga/portofolio',
                "Private": false,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": false,
            }
        },
        {
            "id": 4,
            "name": 'Application for New High School Student Admission process in Indonesia (Web)',
            "category": "web",
            "aboutProject": `In this project I created a web-based application system to help schools with New Student Admissions activities and to build a REST API that would help web-based applications connected to mobile applications. In this application, prospective students can also choose the registration path to follow, such as the "Jalur Zonasi", "Jalur Afirmasi", "Jalur Perpindahan Orang Tua" and "Jalur Prestasi.
        
            This project was created using Python programming language together with the Django Web Framework, the REST API was built using the django rest framework toolkit, the CSS Framework uses Bootstrap and uses MySQL as the database.`,
            "tags": ["HTML + CSS", "Django", "Django Rest API", "Bootstrap", "MySQL"],
            "button": {
                "Demo": 'http://ryan-retired.site/ppdb',
                "Github": 'https://github.com/tisoga/project_skripsi_web_pendaftaran',
                "Private": false,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": false,
            }
        },
        {
            "id": 5,
            "name": 'Application for Monitoring Activities of PT PLN Employees in the Sub Division of Asset Utilization (Web)',
            "category": "web",
            "aboutProject": `The purpose of this application is to record the activities of PT PLN employees in Sub Division of Asset Utilization, so that all employees know the full chronology of the cases they are working on. BThis application also gives a notification when there are new cases or cases approaching the deadline for registered employees via telegram.
            
            This application was created using the Python programming language together with the Django Web Framework, for the CSS Framework with Bootstrap and with MySQL as database. Telegram notifications are sent using the Telegram BOT API.`,
            "tags": ["HTML + CSS", "Django", "Bootstrap", "MySQL", "Telegram BOT"],
            "button": {
                "Demo": false,
                "Github": false,
                "Private": true,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": 'https://postimg.cc/gallery/9hsxJpM',
            }
        },
        {
            "id": 6,
            "name": 'Application for New High School Student Admission process in Indonesia (Mobile)',
            "category": "mobile",
            "aboutProject": `In this project, I created a mobile application to help the school with New Student Admissions activities by fetching data from REST API web-based application that was created. In this application, prospective students can also choose the registration path to follow, such as the destination route, confirmation path, parental migration path and performance path.
        
            This application was created with React Native and uses MySQL as a database.`,
            "tags": ["React Native", "Rest API", "MySQL"],
            "button": {
                "Demo": 'https://bit.ly/ppdb-online-',
                "Github": 'https://github.com/tisoga/PPDB_Online',
                "Private": false,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": 'https://postimg.cc/gallery/5J5Pq99',
            }
        },
        {
            "id": 7,
            "name": 'Application for Monitoring Activities of PT PLN Employees in the Sub Division of Asset Utilization (Mobile)',
            "category": "mobile",
            "aboutProject": `The purpose of this application is to record the activities of PT PLN employees in Sub Division of Asset Utilization, so that all employees know the full chronology of the cases they are working on. By using this mobile application, employees can login without entering their username and password, as long as the IMEI device is registered.
            
            This application was created with Android Stduio Web View using a responsive web application.`,
            "tags": ["Android Studio", "Web View"],
            "button": {
                "Demo": false,
                "Github": false,
                "Private": true,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": 'https://postimg.cc/gallery/9hsxJpM',
            }
        },
    ]
}

export default project